import React from 'react';

// @Component({
//   selector: 'lessonplan-slot-picker',
//   templateUrl: './lessonplan-slot-picker.component.html',
//   styleUrls: ['./lessonplan-slot-picker.component.css']
// })

interface Myprops {
    activitySlots:any,
    notify: any
}
export class LessonplanSlotPicker extends React.Component<Myprops> {


//   @Output() notify: EventEmitter<string> = new EventEmitter<string>();
  
  handleClick(batch:any) {
    console.log('here');
    this.props.notify(batch);
  }
  
  constructor(props:Myprops) {super(props)
  console.log("in lessonslotpicker child")
  }
  componentDidMount(){
    console.log(this.props.activitySlots)
  }

  render(){
      return(
        <div className="lesson-plan-slot-picker">
            {this.props.activitySlots.map((activitySlot:any,i:any) => (
                <div className="card bg-color-blue mb-2" onClick={() => this.handleClick(activitySlot)} key={i}>
                    <div className="card-body">
                    <h5 className="card-title text-light">{activitySlot.batchName}</h5>
                    <h6 className="card-subtitle mb-2 text-light">{activitySlot.opicName}</h6>
                    <p className="card-text text-right text-light">{activitySlot.startTime} &nbsp; - &nbsp;{activitySlot.endTime}</p>
                    </div>
                </div>
            ))}
            </div>
        
      )
  }

}